import React from 'react'
import s from '../../css/profile/profileCode.module.css'

const getExample = token => `fetch('https://kinopoiskapiunofficial.tech/api/v2.2/films/301', {
  method: 'GET',
  headers: {
    'X-API-KEY': '${token}',
    'Content-Type': 'application/json',
  },
})
  .then(res => res.json())
  .then(json => console.log(json))
  .catch(err => console.log(err))`

const ProfileCode = ({ token }) => (
	<section className={s.card}>
		<h3>Пример использования</h3>
		<pre className={s.pre}>
			<code>{getExample(token)}</code>
		</pre>
	</section>
)

export default ProfileCode
